var Errors;
(function (Errors) {
    function alertError(id, message) {
        showErrorModal(message);
        let element = document.getElementById(id);
        if (element) {
            element.focus();
        }
    }
    Errors.alertError = alertError;
    function alertMessage(title, message) {
        showAlertModal(title, message);
    }
    Errors.alertMessage = alertMessage;
    function showErrorModal(message) {
        let modal = document.getElementById("global-error-modal");
        modal.classList.add("show");
        modal.classList.add("d-block");
        let divMessage = document.getElementById("global-error-modal-message");
        divMessage.innerHTML = message;
    }
    Errors.showErrorModal = showErrorModal;
    function closeErrorModal() {
        let modal = document.getElementById("global-error-modal");
        modal.classList.remove("show");
        modal.classList.remove("d-block");
        let divMessage = document.getElementById("global-error-modal-message");
        divMessage.innerHTML = '';
    }
    Errors.closeErrorModal = closeErrorModal;
    function showAlertModal(title, message) {
        let modal = document.getElementById("global-alert-modal");
        modal.classList.add("show");
        modal.classList.add("d-block");
        let divTitle = document.getElementById("alert-header-modalLabel");
        divTitle.innerHTML = title;
        let divMessage = document.getElementById("global-alert-modal-message");
        divMessage.innerHTML = message;
    }
    Errors.showAlertModal = showAlertModal;
    function closeAlertModal() {
        let modal = document.getElementById("global-alert-modal");
        modal.classList.remove("show");
        modal.classList.remove("d-block");
        let divMessage = document.getElementById("global-alert-modal-message");
        divMessage.innerHTML = '';
    }
    Errors.closeAlertModal = closeAlertModal;
})(Errors || (Errors = {}));
